import { render, staticRenderFns } from "./invoice-options-send-to-insurer.vue?vue&type=template&id=0778640c&scoped=true"
import script from "./invoice-options-send-to-insurer.vue?vue&type=script&lang=js"
export * from "./invoice-options-send-to-insurer.vue?vue&type=script&lang=js"
import style0 from "./invoice-options-send-to-insurer.vue?vue&type=style&index=0&id=0778640c&prod&scoped=true&lang=css"
import style1 from "./invoice-options-send-to-insurer.vue?vue&type=style&index=1&id=0778640c&prod&lang=css"
import style2 from "./invoice-options-send-to-insurer.vue?vue&type=style&index=2&id=0778640c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778640c",
  null
  
)

export default component.exports